import { landsIncome } from "../domain/store";
import * as Price from "./Price";
export function getLands(assets) {
    // TODO change logic to not have to do this
    landsIncome.set(0.0);
    const rpAssets = assets.filter((asset) => asset.collection_name === "rplanet");
    const lands = rpAssets.filter((asset) => asset.schema_name.includes("lands"));
    return lands;
}
export function getLandsYield(lands) {
    const landYield = {};
    lands.forEach((land) => {
        var _a, _b, _c;
        const mineral = (_b = (_a = land.data) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        const amount = (_c = land.data) === null || _c === void 0 ? void 0 : _c.base_rate;
        if (!landYield[mineral]) {
            landYield[mineral] = 0;
        }
        landYield[mineral] += amount;
    });
    return Object.entries(landYield).map(([id, value]) => ({
        id,
        value,
    }));
}
export function getLandsYieldPrices(landsYield, pricesInWax, waxPrice) {
    const aetherPrice = Price.getPrice(pricesInWax, "AETHER");
    return landsYield.map(({ id, value }) => {
        const priceInWax = Price.getPrice(pricesInWax, id);
        const wax = value * priceInWax;
        const aeth = wax / aetherPrice;
        const usd = wax * waxPrice;
        return {
            id,
            value,
            wax,
            aeth,
            usd,
        };
    });
}
export function aggregateLandYields(landsYield) {
    let totalWax = 0;
    let totalAeth = 0;
    let totalUSD = 0;
    landsYield.forEach(({ aeth, wax, usd }) => {
        totalAeth += aeth;
        totalWax += wax;
        totalUSD += usd;
    });
    landsIncome.set(totalUSD);
    return {
        wax: totalWax,
        aeth: totalAeth,
        usd: totalUSD,
    };
}
